import { useState } from 'react';
import { PropertyPanel } from './PropertyPanel';
import { LayoutSettings } from './LayoutSettings';
import { ReportViewer } from './ReportViewer';
import { useDesignerStore } from '../store';

type TabId = 'properties' | 'layout' | 'preview';

const TABS: { id: TabId; label: string }[] = [
  { id: 'properties', label: 'Properties' },
  { id: 'layout', label: 'Layout' },
  { id: 'preview', label: 'Preview' },
];

interface RightSidebarProps {
  width?: number;
}

export function RightSidebar({ width }: RightSidebarProps) {
  const { selectedRowId } = useDesignerStore();
  const [activeTab, setActiveTab] = useState<TabId>('properties');

  const effectiveTab: TabId = selectedRowId ? 'properties' : activeTab;

  return (
    <aside
      className="border-l border-gray-200 bg-white flex flex-col flex-shrink-0 overflow-hidden"
      style={width ? { width } : { width: 288 }}
    >
      <div className="flex border-b border-gray-200">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex-1 text-xs font-medium py-2 transition-colors ${
              effectiveTab === tab.id
                ? 'text-blue-600 border-b-2 border-blue-600'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="flex-1 overflow-y-auto">
        {effectiveTab === 'properties' && <PropertyPanel />}
        {effectiveTab === 'layout' && <LayoutSettings />}
        {effectiveTab === 'preview' && <ReportViewer />}
      </div>
    </aside>
  );
}
